// favicon
const config = {
  homepage: 'http://www.cvetek.si',
  email: 'drago.cvetek@gmail.com',
  phone: '04 572 36 60',
  gsm: '041 341 432',
  naslov: "Cvetek d.o.o, Triglavska cesta 23, 4264 Bohinjska Bistrica",
  siteLabel: 'Slikopleskarstvo in suhomontaža Cvetek',
  siteLogoUrl: 'img/react-rapid-logo-512.png',
  footer: {
    message:
      'Slikopleskarstvo in suhomontaža Cvetek',
    copyrightYear: 2022
  },
  socialMediaLinks: [
    {
      id: 'facebook',
      url: 'https://www.facebook.com/Slikopleskarstvo-in-suhomonta%C5%BEa-Cvetek-475761759163471/?fref=ts',
      active: true,
      icon: 'facebook'
    }
  ],
  pages: {
    storitve: {
      component: 'Storitve',
      label: 'Storitve',
      icon: 'lab',
      subTitle:
        'Slikopleskarstvo in suhomontaža Cvetek',
      path: '/storitve'
    },
    reference: {
      component: 'Reference',
      label: 'Reference',
      icon: 'linkify',
      subTitle:
        'Slikopleskarstvo in suhomontaža Cvetek',
      path: '/reference'
    },
    galerija: {
      component: 'Galerija',
      label: 'Galerija',
      icon: 'images',
      subTitle:
        'Galerija slik zaključenih projektov',
      path: '/galerija'
    },
    kontakt: {
      component: 'Kontakt',
      label: 'Kontakt',
      icon: 'phone',
      subTitle:
        'Slikopleskarstvo  in suhomontaža Cvetek',
      path: '/kontakt'
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js